import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Css/Payment.css";
import "./Css/Payment-responsive.css";

import { Ripple } from "primereact/ripple";
import { Nullable } from "primereact/ts-helpers";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import {
  Dropdown,
  DropdownChangeEvent,
  DropdownProps,
} from "primereact/dropdown";

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import NumberInput from "../../Components/NumberInput";
import FileInput from "../../Components/FileInput";
import DatePicker from "../../Components/DatePicker";
import DocumentViewModal from "../../Components/DocumentViewModal";
import { goToTop } from "../../Components/goToTop";
import { baseURL } from "../../Api/ApiConstant";
import { getAppCurrencyType } from "../../Utils/Common";
import { formatDate } from "../../Utils/getDate";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { getAllPaymentInstalment } from "../../Controllers/Thunks/PaymentThunks";
import { Instalment } from "../../Controllers/Types/SiteMenuModel/Payment/Instalment";
import { fetchAllProjects } from "../../Controllers/Thunks/projectThunks";
import { Project } from "../../Controllers/Types/Project/ProjectInterface";
import { createInstalmentService, deleteInstalmentService, updateInstalmentService } from "../../Api/HeyTraderService/PaymentApiService";
import { checkFileOthers, checkModelSelected, checkNumber, checkText } from "../../Utils/Validator";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";
import { format } from "date-fns";
import { FileUpload } from "primereact/fileupload";

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const currencySymbol = getAppCurrencyType();

  const dataLoading = useAppSelector((state) => state?.paymentInstalment?.loader);
  const error = useAppSelector((state) => state?.paymentInstalment?.errorDisplay);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);
  const dialogRef = useRef<Dialog>(null);

  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const menuRefs = useRef<Record<number, Menu | null>>({});
  const buttonRefs = useRef<Record<number, HTMLButtonElement | null>>({});

  const [instalmentFilterState, setInstalmentFilterState] = useState<"All" | "Paid" | "Unpaid" | "Draft">("All");
  const [showPaymentModal, setShowPaymentmodal] = useState<boolean>(false);
  const [showInstalmentViewModal, setShowInstalmentViewModal] = useState<boolean>(false);
  const [instalmentData, setInstalmentData] = useState<Instalment[]>([]);
  const [instalmentsList, setInstalmentsList] = useState<Instalment[]>([]);
  const [filteredInstalmentData, setFilteredInstalmentData] = useState<Instalment[]>([]);
  const [selectedInstalment, setSelectedInstalment] = useState<Instalment | null>(null);
  const [instalmentSearchKey, setInstalmentSearchKey] = useState<string>("");
  const [allInstalmentsCount, setAllInstalmentsCount] = useState<number>(0);
  const [paidInstalmentsCount, setPaidInstalmentsCount] = useState<number>(0);
  const [unpaidInstalmentsCount, setUnpaidInstalmentsCount] = useState<number>(0);
  const [draftInstalmentsCount, setDraftInstalmentsCount] = useState<number>(0);
  const [showInvoiceViewModal, setShowInvoiceViewModal] = useState<boolean>(false);

  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [invoiceNumber, setInvoiceNumber] = useState<string>("1");
  const [instalmentNumber, setInstalmentNumber] = useState<string>("1");
  const [instalmentAmount, setInstalmentAmount] = useState<number | null>(null);
  const [invoiceDate, setInvoiceDate] = useState<Nullable<Date>>(null);
  const [paymentDate, setPaymentDate] = useState<Nullable<Date>>(null);
  const [status, setStatus] = useState<"Paid" | "Unpaid" | "Draft" | null>(null);
  const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
  const [invoiceFileName, setInvoiceFileName] = useState<string>("");
  const invoiceFileRef = useRef<FileUpload>(null);
  const [addNextLoading, setAddNextLoading] = useState<boolean>(false);

  const [projectError, setProjectError] = useState<string>("");
  const [instalmentNumberError, setInstalmentNumberError] = useState<string>("");
  const [instalmentAmountError, setInstalmentAmountError] = useState<string>("");
  const [invoiceDateError, setInvoiceDateError] = useState<string>("");
  const [paymentDateError, setPaymentDateError] = useState<string>("");
  const [statusError, setStatusError] = useState<string>("");
  const [invoiceFileError, setInvoiceFileError] = useState<string>("");
  const [updateHasChanges, setUpdateHasChanges] = useState<boolean>(false);

  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data = useCanEdit("Payment", "create_instalment");
  const edit_data = useCanEdit("Payment", "edit_instalment");
  const delete_data = useCanEdit("Payment", "delete_instalment");

  // for the resons
  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    fetchPaymentInstalmentsData();
    fetchProjectsData();
  }, [dispatch]);

  const fetchPaymentInstalmentsData = async () => {
    await dispatch(getAllPaymentInstalment());
    setInitialDataLoading(false);
  }

  const fetchProjectsData = async () => {
    await dispatch(fetchAllProjects());
  }

  // this is get data from state list and set projectlist
  const payments = useAppSelector((state) => state.paymentInstalment.payments);

  // get all projects
  const projectList = useAppSelector((state) => state.project.allProjects);
  const loadingProjects = useAppSelector((state) => state.project.loading);

  useEffect(() => {
    setInstalmentData(payments?.instalments!);
    setInvoiceNumber(payments?.next_invoice_no!);
  }, [payments]);

  useEffect(() => {
    setProjectsData(projectList);
  }, [projectList]);

  useEffect(() => {
    if (instalmentData && instalmentData?.length > 0) {
      const allCount = instalmentData.length;
      const paidCount = instalmentData.filter((instalment) => instalment?.status === "Paid").length;
      const unpaidCount = instalmentData.filter((instalment) => instalment?.status === "Unpaid").length;
      const draftCount = instalmentData.filter((instalment) => instalment?.status === "Draft").length;

      setAllInstalmentsCount(allCount);
      setPaidInstalmentsCount(paidCount);
      setUnpaidInstalmentsCount(unpaidCount);
      setDraftInstalmentsCount(draftCount);
    } else {
      setAllInstalmentsCount(0);
      setPaidInstalmentsCount(0);
      setUnpaidInstalmentsCount(0);
      setDraftInstalmentsCount(0);
    }
  }, [instalmentData]);

  useEffect(() => {
    if (!instalmentData || instalmentData.length === 0) {
      setFilteredInstalmentData([]);
      setAllInstalmentsCount(0);
      setPaidInstalmentsCount(0);
      setUnpaidInstalmentsCount(0);
      setDraftInstalmentsCount(0);
      return;
    }

    const searchKey = instalmentSearchKey.toLowerCase();

    const searchedData = instalmentData.filter((instalment) => {
      const jobMatch = instalment.job_number?.toLowerCase().includes(searchKey);
      const addressMatch = instalment.address?.toLowerCase().includes(searchKey);
      return jobMatch || addressMatch;
    });

    const allCount = searchedData.length;
    const paidCount = searchedData.filter((i) => i.status === "Paid").length;
    const unpaidCount = searchedData.filter((i) => i.status === "Unpaid").length;
    const draftCount = searchedData.filter((i) => i.status === "Draft").length;

    setAllInstalmentsCount(allCount);
    setPaidInstalmentsCount(paidCount);
    setUnpaidInstalmentsCount(unpaidCount);
    setDraftInstalmentsCount(draftCount);

    let filteredData: typeof searchedData = [];
    if (instalmentFilterState === "All") {
      filteredData = searchedData;
    } else {
      filteredData = searchedData.filter(
        (i) => i.status === instalmentFilterState
      );
    }

    setFilteredInstalmentData(filteredData);
  }, [instalmentData, instalmentFilterState, instalmentSearchKey]);


  useEffect(() => {
    if (dataState === "Add") {
      if (selectedProject && selectedProject !== null) {
        const filteredList = instalmentData?.filter((instalment) => instalment?.project_id === selectedProject?.project_id);
        setInstalmentsList(filteredList);

        if (filteredList?.length > 0) {
          const lastInstalment = filteredList[filteredList.length - 1];

          const lastInstalmentNumber = lastInstalment?.instalment_no?.match(/\d+$/);
          const nextInstalmentNumber = lastInstalmentNumber ? ` ${parseInt(lastInstalmentNumber[0]) + 1}` : "1";

          setInstalmentNumber(nextInstalmentNumber);
        } else {
          setInstalmentNumber("1");
        }

      } else {
        setInstalmentsList([]);
        setInstalmentNumber("1");
      }
    } else {
      if (selectedInstalment) {
        if (selectedProject && selectedProject !== null) {
          const filteredList = instalmentData?.filter((instalment) => instalment?.project_id === selectedProject?.project_id);
          setInstalmentsList(filteredList);

          if (selectedProject?.project_id !== selectedInstalment?.project_id) {
            if (filteredList?.length > 0) {
              const lastInstalment = filteredList[filteredList.length - 1];

              const lastInstalmentNumber = lastInstalment?.instalment_no?.match(/\d+$/);
              const nextInstalmentNumber = lastInstalmentNumber ? ` ${parseInt(lastInstalmentNumber[0]) + 1}` : "1";

              setInstalmentNumber(nextInstalmentNumber);
            } else {
              setInstalmentNumber("1");
            }
          }
        } else {
          setInstalmentsList([]);
          setInstalmentNumber("1");
        }
      }
    }

  }, [selectedProject, instalmentData, dataState, selectedInstalment]);



  /* ******************************* Instalment ******************************* */
  const handleSwitchInstalmentFilterState = (
    state: "All" | "Paid" | "Unpaid" | "Draft"
  ) => {
    setInstalmentFilterState(state);
    setInstalmentSearchKey("");
    goToTop();
  };

  const handleClosePaymentmodal = () => {
    setShowPaymentmodal(false);
    handleClearPaymentFields(false);
    handleClearPaymentErrors();
  };

  const handleClearPaymentFields = (options: boolean) => {
    if (options) {
      setSelectedProject(selectedProject);
    } else {
      setSelectedProject(null);
    }
    setInstalmentNumber("");
    setInstalmentAmount(null);
    setInvoiceDate(null);
    setPaymentDate(null);
    setStatus(null);
    setInvoiceFile(null);
    setInvoiceFileName("");
  };

  const handleClearPaymentErrors = () => {
    setProjectError("");
    setInstalmentNumberError("");
    setInstalmentAmountError("");
    setInvoiceDateError("");
    setPaymentDateError("");
    setStatusError("");
    setInvoiceFileError("");
  };

  const handleAddInstalment = () => {
    setShowPaymentmodal(true);
    setDataState("Add");

    if (selectedProject && selectedProject !== null) {
      const filteredList = instalmentData?.filter((instalment) => instalment?.project_id === selectedProject?.project_id);
      setInstalmentsList(filteredList);

      if (filteredList?.length > 0) {
        const lastInstalment = filteredList[filteredList.length - 1];

        const lastInstalmentNumber = lastInstalment?.instalment_no?.match(/\d+$/);
        const nextInstalmentNumber = lastInstalmentNumber ? ` ${parseInt(lastInstalmentNumber[0]) + 1}` : "1";

        setInstalmentNumber(nextInstalmentNumber);
      } else {
        setInstalmentNumber("1");
      }

    } else {
      setInstalmentsList([]);
      setInstalmentNumber("1");
    }
  };

  const handleAddNextInstalment = async () => {
    if (checkCredentials()) {
      setAddNextLoading(true);

      const data = await createInstalmentService(
        selectedProject?.project_id!,
        invoiceNumber,
        instalmentNumber,
        instalmentAmount!,
        formatDate(invoiceDate!),
        formatDate(paymentDate!),
        status!,
        invoiceFile!
      );

      setAddNextLoading(false);

      if (data.statusCode === 200) {
        fetchPaymentInstalmentsData();
        invoiceFileRef.current?.clear();
        handleClearPaymentFields(true);
        handleClearPaymentErrors();

        if (dialogRef.current) {
          const content = dialogRef.current.getContent();
          if (content) {
            content.scrollTo({ top: 0, behavior: "smooth" });
          }
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the instalment.",
            life: 3000,
          });
        }
      }
    }
  };


  useEffect(() => {
    checkModelSelected(selectedProject !== null, false, setProjectError);
  }, [selectedProject]);

  useEffect(() => {
    checkText(formatDate(invoiceDate!), false, setInvoiceDateError);
  }, [invoiceDate]);

  useEffect(() => {
    checkText(formatDate(paymentDate!), false, setPaymentDateError);
  }, [paymentDate]);

  useEffect(() => {
    checkText(status!, false, setStatusError);
  }, [status]);

  useEffect(() => {
    checkNumber(instalmentAmount!, false, setInstalmentAmountError);
  }, [instalmentAmount]);

  useEffect(() => {
    checkFileOthers(invoiceFile!, false, setInvoiceFileError);
  }, [invoiceFile]);

  function checkCredentials(): boolean {
    if (dataState === "Add") {
      const pro = checkModelSelected(selectedProject !== null, true, setProjectError);
      const invoice_date = checkText(formatDate(invoiceDate!), true, setInvoiceDateError);
      const paymen_date = checkText(formatDate(paymentDate!), true, setPaymentDateError);
      const status_er = checkText(status!, true, setStatusError);
      const amount = checkNumber(instalmentAmount!, true, setInstalmentAmountError);
      const file = checkFileOthers(invoiceFile!, true, setInvoiceFileError);
      return pro && invoice_date && paymen_date && status_er && amount && file;
    } else {
      const pro = checkModelSelected(selectedProject !== null, true, setProjectError);
      const invoice_date = checkText(formatDate(invoiceDate!), true, setInvoiceDateError);
      const paymen_date = checkText(formatDate(paymentDate!), true, setPaymentDateError);
      const status_er = checkText(status!, true, setStatusError);
      const amount = checkNumber(instalmentAmount!, true, setInstalmentAmountError);

      return pro && invoice_date && paymen_date && status_er && amount;
    }
  }



  //   database function for create an installment.
  const handleCreateInstalment = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await createInstalmentService(
        selectedProject?.project_id!,
        invoiceNumber,
        instalmentNumber,
        instalmentAmount!,
        formatDate(invoiceDate!),
        formatDate(paymentDate!),
        status!,
        invoiceFile!
      );

      setLoading(false);
      if (data.statusCode === 200) {
        fetchPaymentInstalmentsData();
        handleClosePaymentmodal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Instalment created successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the instalment.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditInstalment = (data: Instalment) => {
    if (data) {
      setSelectedInstalment(data);
      setShowPaymentmodal(true);
      setDataState("Edit");
      setOpenMenuId(null);

      const project = projectsData?.find(
        (project) => project?.project_id === data?.project_id
      );
      setSelectedProject(project || null);
      setInstalmentNumber(data?.instalment_no || "");
      setInstalmentAmount(data?.instalment_amount || null);
      setInvoiceDate(data?.invoice_date ? new Date(data?.invoice_date) : null);
      setPaymentDate(data?.payment_date ? new Date(data?.payment_date) : null);
      setStatus(data?.status || null);
    } else {
      setSelectedInstalment(null);
      setSelectedProject(null);
      setInstalmentNumber("");
      setInstalmentAmount(null);
      setInvoiceDate(null);
      setPaymentDate(null);
      setStatus(null);
    }
  };

  useEffect(() => {
    if (selectedInstalment) {
      if (selectedProject?.project_id !== selectedInstalment?.project_id) {
        setUpdateHasChanges(true);
      } else if (instalmentAmount !== null && instalmentAmount !== selectedInstalment?.instalment_amount) {
        setUpdateHasChanges(true);
      } else if (instalmentAmount !== null && instalmentAmount !== selectedInstalment?.instalment_amount) {
        setUpdateHasChanges(true);
      } else if (format(invoiceDate!, "MMMM dd, yyyy") !== selectedInstalment?.invoice_date) {
        setUpdateHasChanges(true);
      } else if (format(paymentDate!, "MMMM dd, yyyy") !== selectedInstalment?.payment_date) {
        setUpdateHasChanges(true);
      } else if (status !== selectedInstalment?.status) {
        setUpdateHasChanges(true);
      } else if (invoiceFile !== null) {
        setUpdateHasChanges(true);
      }
      else {
        setUpdateHasChanges(false);
      }
    }
  }, [selectedInstalment, selectedProject, instalmentAmount, invoiceDate, paymentDate, status, invoiceFile]);

  //   update database functions ass well.
  const handleUpdateInstalment = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await updateInstalmentService(
        selectedProject?.project_id!,
        instalmentNumber,
        instalmentAmount!,
        formatDate(invoiceDate!),
        formatDate(paymentDate!),
        status!,
        invoiceFile!,
        selectedInstalment?.instalment_id!
      );

      setLoading(false);
      if (data.statusCode === 200) {
        fetchPaymentInstalmentsData();
        handleClosePaymentmodal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Instalment updated successfully.",
            life: 3000,
          });
        }
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the instalment.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteInstalment = (data: Instalment) => {
    const instalmentId = data?.instalment_id;
    setOpenMenuId(null);

    confirmDialog({
      message: "Are you sure you want to delete this instalment record?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteInstalment(instalmentId!),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteInstalment = async (instalmentId: number) => {
    const result = await deleteInstalmentService(instalmentId);

    if (result.statusCode === 200) {
      fetchPaymentInstalmentsData();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Instalment record deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the instalment record.",
          life: 3000,
        });
      }
    }
  };

  const paymentModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} instalment</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleClosePaymentmodal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const paymentModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleClosePaymentmodal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateInstalment : handleUpdateInstalment}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !updateHasChanges}
      />
    </div>
  );

  const jobNoBodyTemplate = (rowData: Instalment) => {
    return (
      <span className="text_bold">
        <span>{rowData.job_number}</span>
        <small className="table_data_sub text-capitalize">
          {rowData.address}
        </small>
      </span>
    );
  };

  const statusBodyTemplate = (rowData: Instalment) => {
    const status = rowData.status;
    let colorCode = "";

    if (status === "Paid") {
      colorCode = "#20c58e";
    } else if (status === "Unpaid") {
      colorCode = "#f3bc6a";
    } else if (status === "Draft") {
      colorCode = "#b4b4b4";
    }

    return (
      <div className="flex_center">
        <span className="priority_label" style={{ backgroundColor: colorCode }}>
          {status}
        </span>
      </div>
    );
  };

  const handleViewInstalment = (data: Instalment) => {
    if (data) {
      setSelectedInstalment(data);
      setShowInstalmentViewModal(true);
      setOpenMenuId(null);
    } else {
      setSelectedInstalment(null);
    }
  };

  const handleCloseInstalmentViewModal = () => {
    setShowInstalmentViewModal(false);
    setSelectedInstalment(null);
  };

  const instalmentViewModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Instalment details</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseInstalmentViewModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const tableActionMenuItems: MenuItem[] = [
    {
      items: [
        {
          label: "View",
          command: () => {
            if (selectedInstalment !== null) {
              handleViewInstalment(selectedInstalment);
            }
          },
        },

        {
          label: "Edit",
          command: () => {
            if (selectedInstalment !== null) {
              handleEditInstalment(selectedInstalment);
            }
          },
        },

        {
          label: "Delete",
          command: () => {
            if (selectedInstalment !== null) {
              handleDeleteInstalment(selectedInstalment);
            }
          },
        },
      ].filter((e) => (e.label === "Edit" && edit_data) || (e.label === "Delete" && delete_data) || (e.label === "View")),
    },
  ];

  const tableActionMenuToggle = (
    e: React.MouseEvent<HTMLButtonElement>,
    data: Instalment
  ) => {
    e.stopPropagation();
    setSelectedInstalment(data);

    if (openMenuId === data?.instalment_id) {
      menuRefs.current[data?.instalment_id]?.hide(e);
      setOpenMenuId(null);
    } else {
      if (openMenuId !== null && menuRefs.current[openMenuId]) {
        menuRefs.current[openMenuId]?.hide(e);
      }
      menuRefs.current[data?.instalment_id!]?.toggle(e);
      setOpenMenuId(data?.instalment_id!);
    }
  };

  const tableActionBody = (rowData: Instalment) => {
    return (
      <React.Fragment>
        <Button
          ref={(el) => (buttonRefs.current[rowData?.instalment_id as number] = el as HTMLButtonElement | null)}
          key={`menu_toggle_button_${rowData?.instalment_id}`}
          id={`menu_toggle_button_${rowData?.instalment_id}`}
          icon="bi bi-three-dots-vertical"
          className="is_btn action_trigger_btn p-ripple"
          onClick={(e) => tableActionMenuToggle(e, rowData)}
          aria-controls={`popup_menu_${rowData?.instalment_id}`}
          aria-haspopup
        />

        <Menu
          ref={(el) => (menuRefs.current[rowData?.instalment_id!] = el)}
          id={`popup_menu_${rowData?.instalment_id}`}
          key={`popup_menu_${rowData?.instalment_id}`}
          model={tableActionMenuItems}
          popup
          appendTo={document.body}
          className="service_action_menu"
        />
      </React.Fragment>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (openMenuId !== null) {
        const menuElement = menuRefs.current[openMenuId]?.getElement();
        const buttonElement = buttonRefs.current[openMenuId];

        if (
          menuElement &&
          !menuElement.contains(event.target as Node) &&
          buttonElement &&
          !buttonElement.contains(event.target as Node)
        ) {
          const syntheticEvent = {
            stopPropagation: () => { },
            preventDefault: () => { },
          } as React.SyntheticEvent;
          menuRefs.current[openMenuId]?.hide(syntheticEvent);
          setOpenMenuId(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openMenuId]);

  const daysCountBody = (rowData: Instalment) => {
    if (!rowData.payment_date) {
      return <span className="count_label mt-1 mb-1"></span>;
    }

    const dataStatus = rowData.status;
    const today = new Date();

    const dataDueDate = new Date(Date.parse(rowData.payment_date));

    if (isNaN(dataDueDate.getTime())) {
      return <span className="count_label mt-1 mb-1"></span>;
    }

    const timeDiff = dataDueDate.getTime() - today.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return (
      <div className="flex_center">
        <Tooltip
          key={`show_info_${rowData?.instalment_id}`}
          id={`show_info_${rowData?.instalment_id}`}
          target={`.show_info_${rowData?.instalment_id}`}
        />

        {dataStatus === "Unpaid" ? (
          <span
            className={`count_label show_info_${rowData?.instalment_id} mt-1 mb-1`}
            style={{ backgroundColor: "#EF9A9A" }}
            data-pr-tooltip={`${daysDiff} day${daysDiff > 1 ? "s" : ""} left from today`}
            data-pr-position="left"
          >
            {daysDiff > 0 ? "+" : ""}
            {daysDiff}
          </span>
        ) : (
          <span className="count_label mt-1 mb-1"></span>
        )}
      </div>
    );
  };

  const handleProjectChange = (e: DropdownChangeEvent) => {
    const selectedOption = e.value as Project | null;
    setSelectedProject(selectedOption);
  };

  const selectedProjectTemplate = (option: Project, props: DropdownProps) => {
    if (option) {
      return (
        <div className="d-flex align-items-center overflow-hidden">
          <div>
            <b>{option?.job_number}</b>&nbsp;-&nbsp;{option?.address}
          </div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const projectOptionTemplate = (option: Project) => {
    return (
      <div
        className={`address_option_container ${option?.project_type === "CP" ? "bg-blue" : "bg-purple"}`}
      >
        <span>
          <b>{option?.job_number}</b>:&nbsp;
          {option?.address}
        </span>
      </div>
    );
  };

  const handleinstalmentAmountChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setInstalmentAmount(e.value);
    }
  };

  const handleInvoiceFileUpload = (file: File) => {
    setInvoiceFile(file);
    setInvoiceFileName(file.name);
  };

  const handleClearInvoiceFile = () => {
    setInvoiceFile(null);
    setInvoiceFileName("");
  };

  const handleChangeStatus = (
    e: CheckboxChangeEvent,
    option: "Paid" | "Unpaid" | "Draft"
  ) => {
    setStatus(option);
  };

  const handleViewInvoiceFile = () => {
    setShowInvoiceViewModal(true);
  };

  const viewInstalmentStatus = (status: "Paid" | "Unpaid" | "Draft") => {
    let colorCode = "";
    let icon = "";

    if (status === "Paid") {
      colorCode = "#20c58e";
      icon = "bi bi-check-circle";
    } else if (status === "Unpaid") {
      colorCode = "#f3bc6a";
      icon = "bi bi-clock";
    } else if (status === "Draft") {
      colorCode = "#b4b4b4";
      icon = "bi bi-file-earmark-minus";
    }

    return (
      <span className="priority_label" style={{ backgroundColor: colorCode }}>
        <i className={`${icon} me-2`}></i>
        {status}
      </span>
    );
  };
  /* *************************************************************************** */

  /* ***************************** Common function ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {dataLoading && initialDataloading ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="main_heading">Payments</h4>
              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area end_flex mt-sm-3 mt-3">
              <div className="payment_filter_tabs_area">
                <button
                  className={`payment_filter_tab primary ${instalmentFilterState === "All" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("All")}
                >
                  <i className="bi bi-receipt payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">All</span>
                    <span className="payment_filter_count">
                      {String(allInstalmentsCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(128, 100, 209, 0.2)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab success ${instalmentFilterState === "Paid" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Paid")}
                >
                  <i className="bi bi-check-circle payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Paid</span>
                    <span className="payment_filter_count">
                      {String(paidInstalmentsCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple
                    pt={{ root: { style: { background: "rgba(32, 197, 142, 0.2)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab warning ${instalmentFilterState === "Unpaid" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Unpaid")}
                >
                  <i className="bi bi-clock payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Unpaid</span>
                    <span className="payment_filter_count">
                      {String(unpaidInstalmentsCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(243, 188, 106, 0.3)" } } }} />
                </button>

                <button
                  className={`payment_filter_tab secondary ${instalmentFilterState === "Draft" && " active"} p-ripple`}
                  role="tab"
                  type="button"
                  onClick={() => handleSwitchInstalmentFilterState("Draft")}
                >
                  <i className="bi bi-file-earmark-minus payment_filter_icon"></i>
                  <div className="payment_filter_sub">
                    <span className="payment_filter_title">Draft</span>
                    <span className="payment_filter_count">
                      {String(draftInstalmentsCount).padStart(2, "0")}
                      &nbsp;Invoices
                    </span>
                  </div>
                  <Ripple pt={{ root: { style: { background: "rgba(180, 180, 180, 0.3)" } } }} />
                </button>
              </div>

              <div className="page_action_area wrap_flex">
                <div className="filter_input_group">
                  <IconField iconPosition="right">
                    {instalmentSearchKey === "" ? (
                      <InputIcon className="bi bi-search"></InputIcon>
                    ) : (
                      <InputIcon
                        className="bi bi-x-lg search_clear_icon"
                        onClick={() => setInstalmentSearchKey("")}
                      ></InputIcon>
                    )}

                    <InputText
                      key={`instalmentSearchKey`}
                      id="instalmentSearchKey"
                      value={instalmentSearchKey}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInstalmentSearchKey(e.target.value)}
                      className="custom_form_input filter_input auto_width"
                      placeholder="Search by address/job no."
                      type="search"
                    />
                  </IconField>
                </div>

                {(add_data) && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddInstalment}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add instalment</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_main_content_section p-0">
              {instalmentData && instalmentData?.length > 0 ? (
                <DataTable
                  value={filteredInstalmentData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No records found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: "50rem", maxHeight: '55vh' }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table p-0 p-sm-2"
                  rowHover
                  scrollable
                  loading={dataLoading}
                  scrollHeight="55vh"
                >
                  <Column
                    header="Job No."
                    field="job_number"
                    headerClassName="text_purple"
                    alignHeader={"left"}
                    body={jobNoBodyTemplate}
                    style={{ width: "1  5%" }}
                  ></Column>

                  <Column
                    header="Instalment no."
                    headerClassName="text_purple"
                    field="instalment_no"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap">
                        {rowData?.instalment_no ? rowData?.instalment_no : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Invoice date"
                    headerClassName="text_purple"
                    field="invoice_date"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap">
                        {rowData?.invoice_date ? rowData?.invoice_date : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Due date"
                    headerClassName="text_purple"
                    field="payment_date"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap">
                        {rowData?.payment_date ? rowData?.payment_date : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Amount"
                    headerClassName="text_purple"
                    alignHeader={"right"}
                    field="instalment_amount"
                    className="text_bold"
                    body={(rowData: Instalment) => (
                      <span className="text_no_wrap flex_end">
                        {currencySymbol}&nbsp;
                        {rowData?.instalment_amount ? rowData?.instalment_amount.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : "---"}
                      </span>
                    )}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    header="Status"
                    alignHeader={"center"}
                    field="status"
                    headerClassName="text_purple"
                    body={statusBodyTemplate}
                    style={{ width: "15%" }}
                  ></Column>

                  <Column
                    body={daysCountBody}
                    style={{ width: "5%" }}
                  ></Column>

                  <Column
                    body={tableActionBody}
                    style={{ width: "5%" }}
                    frozen
                    alignFrozen="right"
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated
                  message={`No payment instalment(s) data found. ${add_data ? 'To add, click on the Add button.' : ''}`}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Payment modal */}
      <Dialog
        visible={showPaymentModal}
        headerClassName="custom_modal_header"
        header={paymentModalHeader}
        footer={paymentModalFooter}
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleClosePaymentmodal}
        dismissableMask
        closeOnEscape={false}
        contentClassName={`${dataState === "Add" && "pb-0"}`}
        ref={dialogRef}
      >
        <div className="custom_modal_body pb-0">
          <div className="p-1 pt-2 pb-0 p-sm-4 pt-sm-2 pb-sm-0 w-100">
            <div className="row">
              {/* Project */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="Project"
                    className="custom_form_label is_required"
                  >
                    Project
                  </label>
                  <Dropdown
                    key={`Project`}
                    id="Project"
                    value={selectedProject}
                    onChange={handleProjectChange}
                    options={projectsData}
                    optionLabel="job_number"
                    valueTemplate={selectedProjectTemplate}
                    itemTemplate={projectOptionTemplate}
                    emptyFilterMessage="No project(s) found!"
                    placeholder="Select project"
                    className="form_dropdown address_selection w-100"
                    filter
                    showClear
                    filterInputAutoFocus
                    filterBy="job_number,address"
                    filterPlaceholder="Search by address/job no."
                    panelClassName="address_dropdown_panel"
                    loading={loadingProjects}
                  />

                  {projectError && (
                    <small className="form_error_msg">{projectError}</small>
                  )}
                </div>
              </div>

              {/* Installemnt list */}
              {instalmentsList && instalmentsList?.length > 0 && (
                <div className="col-12">
                  {(dataState === "Add" || (dataState === 'Edit' && selectedProject?.project_id !== selectedInstalment?.project_id)) && (
                    <div className="page_form_group">
                      <div className="row instalment_list_row">
                        {instalmentsList?.map((instalment) => (
                          <div
                            key={instalment?.instalment_id}
                            className="col-6 col-sm-4 instalment_list_column"
                          >
                            <article className="instalment_list">
                              <span className="text-capitalize">
                                {instalment?.instalment_no}
                              </span>
                            </article>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Instalment number */}
              <div className="col-12 col-sm-6">
                <div className="page_form_group">
                  <label
                    htmlFor="instalmentNumber"
                    className="custom_form_label"
                  >
                    Instalment no.&nbsp;
                    <small>
                      {dataState === "Add" ? "(Auto generated)" : "(Can't modify)"}
                    </small>
                  </label>
                  <InputText
                    key={`instalmentNumber`}
                    id="instalmentNumber"
                    value={
                      (dataState === "Add" ||
                        (dataState === 'Edit' && selectedProject?.project_id !== selectedInstalment?.project_id)) ?
                        `Instalment no ` + instalmentNumber : instalmentNumber
                    }
                    className="custom_form_input"
                    placeholder="Instalment number"
                    disabled
                  />

                  {instalmentNumberError && (
                    <small className="form_error_msg">
                      {instalmentNumberError}
                    </small>
                  )}
                </div>
              </div>

              {/* Instalment amount */}
              <div className="col-12 col-sm-6">
                <NumberInput
                  key={`instalmentAmount`}
                  inputId="instalmentAmount"
                  label="Instalment amount"
                  labelHtmlFor="instalmentAmount"
                  placeholder="Enter amount"
                  onChange={handleinstalmentAmountChange}
                  value={instalmentAmount}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  prefix={currencySymbol + " "}
                  error={instalmentAmountError}
                />
              </div>

              {/* Invoice date */}
              <div className="col-12 col-sm-6">
                <DatePicker
                  key={`invoiceDate`}
                  id="invoiceDate"
                  label="Invoice date"
                  labelHtmlFor="invoiceDate"
                  required={true}
                  value={invoiceDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setInvoiceDate}
                  error={invoiceDateError}
                  showClear
                  onClear={() => setInvoiceDate(null)}
                />
              </div>

              {/* Payment date */}
              <div className="col-12 col-sm-6">
                <DatePicker
                  key={`paymentDate`}
                  id="paymentDate"
                  label="Payment date"
                  labelHtmlFor="paymentDate"
                  required={true}
                  value={paymentDate}
                  placeholder="dd/mm/yyyy"
                  onChange={setPaymentDate}
                  error={paymentDateError}
                  showClear
                  onClear={() => setPaymentDate(null)}
                />
              </div>

              {/* Status */}
              <div className={`col-12 col-sm-6`}>
                <div className="page_form_group">
                  <label
                    htmlFor="status"
                    className="custom_form_label is_required"
                  >
                    Status
                  </label>
                  <div className="response_state_area justify-content-between mb-3">
                    <div className="response_state">
                      <Checkbox
                        inputId="Paid"
                        name="status"
                        value={status}
                        onChange={(e) => handleChangeStatus(e, "Paid")}
                        checked={status === "Paid"}
                      />
                      <label htmlFor="Paid">Paid</label>
                    </div>

                    <div className="response_state">
                      <Checkbox
                        inputId="Unpaid"
                        name="status"
                        value={status}
                        onChange={(e) => handleChangeStatus(e, "Unpaid")}
                        checked={status === "Unpaid"}
                      />
                      <label htmlFor="Unpaid">Unpaid</label>
                    </div>

                    <div className="response_state">
                      <Checkbox
                        inputId="Draft"
                        name="status"
                        value={status}
                        onChange={(e) => handleChangeStatus(e, "Draft")}
                        checked={status === "Draft"}
                      />
                      <label htmlFor="Draft">Draft</label>
                    </div>
                  </div>

                  {statusError && (
                    <small className="form_error_msg">{statusError}</small>
                  )}
                </div>
              </div>

              <div className="col-12 col-sm-6">
                <div className="page_form_group">
                  <label
                    htmlFor="invoiceNumber"
                    className="custom_form_label"
                  >
                    Invoice no.&nbsp;
                    <small>
                      {dataState === "Add" ? "(Auto generated)" : "(Can't modify)"}
                    </small>
                  </label>
                  <InputText
                    key={`invoiceNumber`}
                    id="invoiceNumber"
                    value={invoiceNumber}
                    className="custom_form_input"
                    placeholder="Invoice number"
                    disabled
                  />

                  {instalmentNumberError && (
                    <small className="form_error_msg">
                      {instalmentNumberError}
                    </small>
                  )}
                </div>
              </div>

              {/* Invoice */}
              <div className="col-12">
                <FileInput
                  ref={invoiceFileRef}
                  key={`invoiceFile`}
                  id="invoiceFile"
                  label="Add invoice"
                  labelHtmlFor="invoiceFile"
                  required={true}
                  value={invoiceFileName}
                  canUploadImage={true}
                  onUpload={handleInvoiceFileUpload}
                  onClear={handleClearInvoiceFile}
                  toast={toast}
                  error={invoiceFileError}
                />
              </div>

              <div className="col-12">
                <div className="note_text_label mb-1">
                  <span>Note:</span>

                  <ul className="note_text_content">
                    <li>We will start work once you have paid.</li>
                    <li>The start date will be the payment date.</li>
                  </ul>
                </div>
              </div>
            </div>

            {dataState === "Add" && (
              <div className="flex_end w-100 mt-4 add_task_btn_area">
                <button
                  className={`add_data_btn p-ripple`}
                  onClick={handleAddNextInstalment}
                  disabled={addNextLoading}
                >
                  <i className={`${addNextLoading ? 'ri-loader-4-fill loading_spinner' : 'bi bi-plus-circle'}`}></i>
                  {addNextLoading ? 'Processing...' : 'Add next instalment'}
                  <Ripple />
                </button>
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Instalment view modal */}
      <Dialog
        visible={showInstalmentViewModal}
        header={instalmentViewModalHeader}
        headerClassName="custom_modal_header"
        className={`custom_modal_dialog modal_dialog_sm`}
        onHide={handleCloseInstalmentViewModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1">
            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Project:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content text_purple">
                  {selectedInstalment?.job_number}:{" "}
                  {selectedInstalment?.address}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Instalment number:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.instalment_no ? selectedInstalment?.instalment_no : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Amount:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {currencySymbol}&nbsp;
                  {selectedInstalment?.instalment_amount ? selectedInstalment?.instalment_amount?.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Invoice date:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.invoice_date ? selectedInstalment?.invoice_date : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Payment date:</h6>
              </div>
              <div className="col-7">
                <p className="data_view_content">
                  {selectedInstalment?.payment_date ? selectedInstalment?.payment_date : "---"}
                </p>
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">File:</h6>
              </div>
              <div className="col-7">
                {selectedInstalment?.invoice !== null ? (
                  <button
                    className="data_file_view_button is_btn p-ripple"
                    onClick={handleViewInvoiceFile}
                  >
                    <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                    {selectedInstalment?.invoice?.split("/").pop()}
                    <Ripple />
                  </button>
                ) : (
                  <p className="data_view_detail text_italic">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    No file uploaded!
                  </p>
                )}
              </div>
            </div>

            <hr className="custom_horizontal_line" />

            <div className="row">
              <div className="col-5">
                <h6 className="data_view_title">Status:</h6>
              </div>
              <div className="col-7">
                {viewInstalmentStatus(selectedInstalment?.status!)}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Invoice file view modal */}
      <DocumentViewModal
        isOpen={showInvoiceViewModal}
        fileUrl={baseURL + selectedInstalment?.invoice}
        onClose={() => setShowInvoiceViewModal(false)}
      />
      {/*  */}
    </React.Fragment>
  );
};

export default Payment;
